module.exports = __webpack_public_path__ + "static/media/5th_banner_item1.a72c9ba4.png";